import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { format } from 'date-fns';
import { BsModalService } from 'ngx-bootstrap/modal';
import { keyService } from '../api-services/keycloak/service/key.service';
import { ProfileService } from '../api-services/profile/profile.service';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
/**
 * This component for  user can selected service and their information to submit. 
 */
@Component({
  selector: 'app-book-service',
  templateUrl: './book-service.component.html',
  styleUrls: ['./book-service.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookServiceComponent implements OnInit {
  @ViewChild('msg') modalDialog;
  cal: Date
  bsconfig: any = {}
  mindate = new Date();
  selectedId: any;
  schdTime: any;
  subCat: any;
  nxtBtn: boolean = true;
  getAddress: any = [];
  reqForm = new FormGroup({
    customerName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(35), Validators.pattern('^[a-zA-Z \-\']+')]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phoneNumber: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
    serviceCatagory: new FormControl(''),
    message: new FormControl(''),
    serviceName: new FormControl(''),
    serviceDate: new FormControl(''),
    serviceDateTime: new FormControl(''),
    serviceAddressId: new FormControl('')
  })
  category: any;
  loggedIn: boolean;
  loggedUser: string[];
  userDetails: any;
  getAddressId;
  select_address: any
  constructor(private activeRouter: ActivatedRoute, private service: TalkToDoctorService, private modal: BsModalService,
    private login_service: keyService, private getDetails: ProfileService, private changeDetectorRef: ChangeDetectorRef) { }
    /**
     * This method using to initalize data like displaying
     * address,user selected service and if userlogged in to show there information 
     */
  async ngOnInit() {
    this.subCat = this.activeRouter.snapshot.queryParams.subCat;
    this.category = this.activeRouter.snapshot.queryParams.cat

    this.bsconfig = {
      showWeekNumbers: false,
      minDate: this.mindate
    };
    this.cal = this.mindate;
    this.selectedId = '1';
    this.schdTime = '10:00 AM';
    this.selectedTime(this.selectedId, this.schdTime);
    this.get_ServiceAddress();
    this.loggedIn = await this.login_service.isLoggedIn();
    if (this.loggedIn) {
      this.loggedUser = this.login_service.getRoles();
      if (this.loggedUser.includes('member')) {
        this.getDetails.getMemberProfile().subscribe(res => {
          this.userDetails = res;
          this.reqForm.get('customerName').patchValue(this.userDetails.firstName);
          this.reqForm.get('email').patchValue(this.userDetails.email);
          this.reqForm.get('phoneNumber').patchValue(this.userDetails.phoneNumber);
        })
      } else if (this.loggedUser.includes('doctor')) {
        this.getDetails.getDoctorProfile().subscribe(res => {
          this.userDetails = res;
          this.reqForm.get('customerName').patchValue(this.userDetails.firstName);
          this.reqForm.get('email').patchValue(this.userDetails.email);
          this.reqForm.get('phoneNumber').patchValue(this.userDetails.mobile);
        })
      }
    }

  }

  get_ServiceAddress() {
    this.service.getServiceAddress().subscribe((res: any) => {
      this.getAddress = res;
      this.selectedAddress(this.activeRouter.snapshot.queryParams.id);
      this.changeDetectorRef.detectChanges();
    })
  }

  modalClose() {
    this.modal.config.initialState = "";
    this.modal.hide();
  }

  selectedTime(id, time) {
    this.selectedId = id;
    this.schdTime = time;
  };
  selectedAddress(id) {
    this.getAddressId = id;
    this.select_address = this.getAddress.find((val) => {
      return val.id == id
    })
  }


/**
 * This method to get all the information user provide and submit it.
 * @returns This return can check validation for input field
 */

  submitReq() {
    if (!this.reqForm.valid) {
      return this.reqForm.markAllAsTouched();
    } else {
      let dateTime = this.schdTime.split(" ")[0].split(":");
      if (this.schdTime.split(" ")[1] == "PM") dateTime[0] = Number(dateTime[0]) + 12;
      this.cal.setHours(dateTime[0]);
      this.cal.setMinutes(dateTime[1]);
      this.cal.setSeconds(0)
      this.cal = new Date(this.cal)
      this.reqForm.get('serviceDate').patchValue(format(this.cal, 'dd/MM/yyyy'));
      this.reqForm.get('serviceDateTime').patchValue(this.cal);
      this.reqForm.get('serviceCatagory').patchValue(this.category);
      this.reqForm.get('serviceName').patchValue(this.subCat);
      this.reqForm.get('serviceAddressId').patchValue(this.getAddressId);
      this.service.postServiceData(this.reqForm.value).subscribe((res: any) => {
        if (res.status) {
          this.modal.show(this.modalDialog,
            {
              backdrop: 'static',
              keyboard: false,
              initialState: {
                message: res.message
              }
            });
          this.reset();
        } else {
          this.modal.show(this.modalDialog,
            {
              backdrop: 'static',
              keyboard: false,
              initialState: {
                message: res.message
              }
            })
        }

      }, err => {
        this.modal.show(this.modalDialog,
          {
            backdrop: 'static',
            keyboard: false,
            initialState: {
              message: err.error.message
            }
          })
      })
    }
  }

  reset() {
    this.reqForm.reset();
    this.cal = this.mindate;
    this.selectedId = '1';
    this.schdTime = '10:00 AM';
    this.nxtBtn = true;
  }


}
